var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.quotaTypes,"item-value":"value","item-text":"text","label":_vm.$t('transportationPermission.quotaType', 'Quota type'),"disabled":_vm.disabled},model:{value:(_vm.selectedQuotaType),callback:function ($$v) {_vm.selectedQuotaType=$$v},expression:"selectedQuotaType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }